import { render, staticRenderFns } from "./AssessmentConsentDialog.vue?vue&type=template&id=9d2981cc&scoped=true&"
import script from "./AssessmentConsentDialog.vue?vue&type=script&lang=ts&"
export * from "./AssessmentConsentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentConsentDialog.vue?vue&type=style&index=0&id=9d2981cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2981cc",
  null
  
)

export default component.exports